import { waitForElementById } from "@/utils";

let cleanup: (() => void) | null = null;

export async function setupAutoBind(api: any, triggerId?: string) {
  if (!triggerId) return;

  if (import.meta.env.DEV || window.__KCW_DEBUG__) {
    console.debug("[telekomId-widget] setupAutoBind triggerId:", triggerId);
  }
  try {
    const triggerHost = await waitForElementById(triggerId);
    if (import.meta.env.DEV || window.__KCW_DEBUG__) {
      console.debug(
        "[telekomId-widget] setupAutoBind found triggerHost:",
        triggerHost,
      );
    }
    await api.mount({
      host: triggerHost,
    });
    if (import.meta.env.DEV || window.__KCW_DEBUG__) {
      console.debug("[telekomId-widget] setupAutoBind mounted successfully");
    }
  } catch (err) {
    console.warn("[telekomId-widget] setupAutoBind failed:", err);
  }
}

export const teardownAutoBind = () => {
  cleanup?.();
  cleanup = null;
};
